import type { QuestionType } from "./types";

const TYPE_LABEL: Record<QuestionType, string> = {
  mc: "MULTIPLE CHOICE",
  truefalse: "TRUE / FALSE",
  multi: "PICK ALL THAT APPLY",
};

/** The small-caps eyebrow shown above a question, e.g. "MULTIPLE CHOICE · 1,000 PTS". */
export function questionEyebrow(type: QuestionType, points: number): string {
  return `${TYPE_LABEL[type]} · ${points.toLocaleString("en-US")} PTS`;
}

/** Default answer-tile keys by slot (also the colour/glyph key). */
export const OPTION_KEYS = ["a", "b", "c", "d"] as const;

/** Public URL for an R2-stored media object (question/answer image). */
export function mediaUrl(key: string | undefined | null): string | undefined {
  return key ? `/media/${key}` : undefined;
}
